import { getUserInfoSync } from '../config/api'

/** True when the logged-in user's company has small shop mode enabled. */
export const isSmallShopMode = () => {
  const userInfo = getUserInfoSync()
  return userInfo?.company?.small_shop_mode === true
}

/** Query param key for stock location: branch_id in small shop mode, warehouse_id otherwise. */
export const locationIdKey = () => (isSmallShopMode() ? 'branch_id' : 'warehouse_id')

/** Build query params for filtering stock by location. */
export const locationQueryParams = (id) =>
  isSmallShopMode() ? { branch_id: id } : { warehouse_id: id }

/** Read location id from a stock entry object. */
export const getLocationIdFromStock = (stock) => {
  if (!stock) return null
  if (isSmallShopMode()) {
    return stock.branch ?? stock.branch_id ?? null
  }
  return stock.warehouse ?? stock.warehouse_id ?? null
}

const WAREHOUSE_HEADER_ALIASES = new Set(['warehouse_id', 'warehouse id', 'warehouse'])

/** Replace warehouse column headers with branch_id for small-shop Excel imports. */
export const normalizeExcelHeaderForSmallShop = (header) => {
  if (header == null) return header
  const normalized = String(header).trim().toLowerCase()
  return WAREHOUSE_HEADER_ALIASES.has(normalized) ? 'branch_id' : header
}

/** Screens that should not be reachable in small shop mode (warehouse-centric). */
export const SMALL_SHOP_HIDDEN_SCREENS = [
  'manage-stocks',
  'stock-adjustments',
  'return-to-warehouse',
  'add-warehouse',
  'manage-warehouses',
  'transfer-stocks',
]
